import React from "react";
import Grid from "@mui/material/Grid2";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";

// Soft UI Dashboard React example components
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";

import ProcesosTable from "./components/procesosTable";

const ProcesosAdmin = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox mt={1} mb={1}>
        <Grid size={12}>
          <ProcesosTable />
        </Grid>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
};

export default ProcesosAdmin;
